import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { variables } from 'components/Theme';

export const useStyle = makeStyles((theme) => ({
  page: {
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    background: variables.palette.grey[100],
    marginBottom: '-70px',
  },

  disabledLink: {
    pointerEvents: 'none',
  },

  // content page
  content: {
    background: '#f9f9f9',
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    overflow: 'auto',
    padding: '20px 50px 80px 50px',
    position: 'relative',
    ['&.--register' as any]: {
      display: 'block',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px 20px 80px 20px',
    },
  },

  // logo
  logo: {
    textAlign: 'center',
    width: '220px',
  },

  // title
  title: {
    textAlign: 'center',

    ['& h1' as any]: {
      fontSize: '23px',
      lineHeight: '23px',
      display: 'block',
      marginBottom: 20,
    },

    ['& h3' as any]: {
      fontSize: '16px',
      lineHeight: '16px',
      color: '#7c8593',
      fontWeight: 400,
      marginBottom: 20,

      ['& a' as any]: {
        color: '#111111',
        fontWeight: 500,
        marginLeft: 2,
      },
    },
  },

  // form
  form: {
    width: '100%',

    ['& .form__item' as any]: {
      marginBottom: 15,

      ['& label span p' as any]: {
        color: red[600],
      },
    },
  },

  // button submit
  buttonSubmit: {
    background: green[700],
    color: 'white',
    fontWeight: 400,
    margin: '12px 0 20px',

    '&:hover': {
      background: green[800],
    },
  },

  // forgot
  forgot: {
    width: '100%',
    textAlign: 'center',

    ['& a' as any]: {
      color: '#111111',
    },
  },

  // footer (links and copyright)
  footer: {
    fontSize: 13,
    color: '#596375',
    fontWeight: 400,
    position: 'absolute',
    bottom: 20,

    ['& p' as any]: {
      margin: 0,
    },

    ['& a' as any]: {
      color: '#596375',
      fontWeight: 400,

      '&:hover': {
        color: '#111111',
      },
    },
  },

  // background (image)
  backgroundPage: {
    width: '100%',
    minHeight: '100vh',
    height: '100%',
    padding: 30,
    position: 'relative',

    ['&:after' as any]: {
      content: '""',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      position: 'absolute',
      background: '-webkit-radial-gradient(51% -13%,rgba(128,139,157,0) 49%,#192542 100%)',
      pointerEvents: 'none',
      zIndex: 1,
    },
  },

  // text in image
  textImage: {
    width: '290px',
    height: 'auto',
    position: 'absolute',
    bottom: '50px',
    left: '50px',
    color: '#fff',
    lineHeight: '23px',
    fontSize: '16px',
    zIndex: 2,

    ['& svg' as any]: {
      marginTop: 15,
    },
  },
}));
